import { Badge } from "@/components/ui/shadcn/Badge/Badge";
import type { MedicalTreatmentAppointment } from "@/lib/types";

export function TreatmentAppointmentOutcomeBadge({
  appointment,
}: {
  appointment: Pick<MedicalTreatmentAppointment, "outcome" | "missedReason">;
}) {
  if (!appointment.outcome) return null;

  return (
    <Badge
      variant={
        appointment.outcome === "missed"
          ? "red"
          : appointment.outcome === "attended"
            ? "green"
            : "blue"
      }
      className="whitespace-normal"
    >
      {appointment.outcome === "missed"
        ? `Missed${appointment.missedReason ? ` · ${appointment.missedReason}` : ""}`
        : appointment.outcome === "attended"
          ? "Attended"
          : "Scheduled"}
    </Badge>
  );
}
